import type { SvgIconComponent } from '@mui/icons-material';
import {
  AssignmentTurnedInOutlined,
  AutorenewOutlined,
  PersonSearchOutlined,
  TaskAltOutlined,
} from '@mui/icons-material';

export type Cn01WorkflowStep = {
  label: string;
  Icon: SvgIconComponent;
};

export const CN01_WORKFLOW_STEPS: Cn01WorkflowStep[] = [
  { label: 'Application Submitted', Icon: AssignmentTurnedInOutlined },
  { label: 'Assigned to Inspector', Icon: PersonSearchOutlined },
  { label: 'Processing', Icon: AutorenewOutlined },
  { label: 'Completed', Icon: TaskAltOutlined },
];

export function isCn01Rejected(status: string): boolean {
  return status === 'r';
}

/** Number of steps marked complete (blue check) for a given status code. */
export function completedStepCountFromStatus(status: string): number {
  switch (status) {
    case 's':
      return 1;
    case 'a':
      return 2;
    case 'p':
      return 3;
    case 'c':
      return 4;
    case 'r':
      return 5;
    default:
      return 0;
  }
}

export function formatStatusCreatedAt(iso: string): string {
  if (!iso?.trim()) return '—';
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return iso;
  return parsed.toLocaleDateString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}

export function displayPermitNo(permitNo: string | null | undefined): string {
  const trimmed = permitNo?.trim();
  return trimmed ? trimmed : '—';
}
